import configureStore from './configureStore';
import { setStore } from './storeRef';

/**
 * Create a store inside this file. Then import this store anywhere it is required
 * Avoid importing this file if not required. Always try to use connect method etc to get store
 */
const store = configureStore();
setStore(store);

if (process.env.REACT_APP_E2E_TESTING === 'true') {
  (window as any).__REDUX_STORE__ = store;
}

export default store;
